import { render, staticRenderFns } from "./MatchmakingPendingModal.vue?vue&type=template&id=2602c57f&"
import script from "./MatchmakingPendingModal.vue?vue&type=script&lang=js&"
export * from "./MatchmakingPendingModal.vue?vue&type=script&lang=js&"
import style0 from "./MatchmakingPendingModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports